{
    "picker__title": "Période",
    "option__today": "Aujourd'hui",
    "option__yesterday": "Hier",
    "option__last_week": "Semaine dernière",
    "option__last_month": "Mois dernier",
    "option__last_quarter": "3 derniers mois",
    "option__ttm": "12 derniers mois",
    "option__ytd": "Année en cours",
    "option__full_year": "Année complète",
    "option__custom": "Dates personnalisées"
}
